import React, { useContext } from "react";
import AdvancedSearchModal from "../modals/advanceSearchModal";
import { useState } from "react";
import DownloadModal from "../modals/downloadModal";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../../reusableComponents/CustomButton";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { useAuth } from "../../context/API_Client";
import OrderManagementContext from "../../context/orderManagement.context";
import FileSaver from "file-saver";

function AllTransactionButton({ setLoading }) {
  const [showAdvancedModal, setAdvancedModal] = useState(false);
  const { filters } = useContext(OrderManagementContext);
  const { getDownloadFileWithFilters } = useAuth();
  const [buttonLoader, setButtonLoader] = useState()
  const [showDownloadModal, setshowDownloadModal] = useState(false);

  const handleCloseAdvancedSearchModal = () => {
    setAdvancedModal(false);
  };

  const handleDownloadModal = () => {
    setButtonLoader(true)
    getDownloadFileWithFilters(filters, function (data) {
      const contentDisposition = data.headers["content-disposition"];
      const match = contentDisposition.match(/filename="(.+?)"/);
      const contentType = data.headers["content-type"];

      let filename;
      if (match && match[1]) {
        filename = match[1];
      } else {
        filename = "Data.csv";
      }
      const blob = new Blob([data.data], {
        type: contentType,
      });
      setLoading(true)
      setButtonLoader(false)
      FileSaver.saveAs(blob, filename);
      successfulToast();
    },
      function (errorMsg) {
        customToast("error", "high", errorMsg);
        setLoading(false)
      }
    );
  };
  const handleCloseDownloadModal = () => {
    setshowDownloadModal(false);
  };

  const successfulToast = () => {
    setTimeout(() => {
      setLoading(false)
    }, 1000);
    customToast("success", "high", "Download successful");
  };

  return (
    <div>
      <CustomButton
        variant={"contained"}
        size={"md"}
        type={"primary"}
        text={"Download CSV"}
        loading={buttonLoader}
        onClick={() => handleDownloadModal()}
      />

      <AdvancedSearchModal
        openModal={showAdvancedModal}
        onClose={handleCloseAdvancedSearchModal}
      />

      <DownloadModal
        openModal={showDownloadModal}
        onClose={handleCloseDownloadModal}
        toastState={successfulToast}
        setLoading={setLoading}
      />
    </div>
  );
}

export default AllTransactionButton;
